<script lang="ts">
	import { Text } from '@Shelly/shelly-design-system';
	import { createEventDispatcher, getContext } from 'svelte';
	import { format } from 'svelte-i18n';

	import BrightnessSlider from '../SchedulesHelpers/BrightnessSlider.svelte';
	import { capFirstChar } from 'src/helpers/utilities';

	export let disabled = false;

	const scheduleStore: SvelteStore<any> = getContext('schedule');

	let brightness =
		typeof $scheduleStore.brightness !== 'number' && typeof $scheduleStore.brightness !== 'undefined'
			? typeof $scheduleStore.brightness === 'string' && $scheduleStore.brightness.length < 1
				? '0'
				: $scheduleStore.brightness.replace('%', '')
			: $scheduleStore.brightness;
	const dispatch = createEventDispatcher();
	const changeBrightness = (e) => {
		dispatch('update', { brightness: `${e.detail}` });
	};
</script>

<Text element="h2" class="mb-m">
	{$format('select_type', {
		values: { type: $format('label_brightness') },
	})}
</Text>
<BrightnessSlider
	{disabled}
	title={capFirstChar($format('collapse_title_brightness'))}
	value={brightness}
	on:change={changeBrightness}
/>
